module.exports = __webpack_public_path__ + "img/wlLogo.f4cc72de.png";